import { makeStyles } from "@material-ui/core";
const FTLTableStyles = makeStyles((theme) => ({
    root: {
        overflow: "hidden",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            width: 0,
        },
    },
    table: {
        borderCollapse: "collapse",
        borderSpacing: 0,
        width: "100%",
        "& tr:hover td$showOnHover, & tr:focus td$showOnHover": {
            opacity: 1,
        },
    },
    overflowTableWrapper: {
        display: "block",
        overflowX: "auto",
        overflowY: "auto",
        maxHeight: "100%",
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
    noDataMessage: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        flexDirection: "column",
        height: 322,
    },
    showOnHover: {
        width: "100%",
        "&[data-sticky-td]:not(td), &td:not(td)": {
            background: "none !important",
        },
        "&[data-sticky-td]:not(th), &td:not(th)": {
            opacity: 0,
            "&:hover:not(th), &:focus:not(th)": {
                opacity: 1,
            },
        },
        "&[data-sticky-first-right-td]:not(th) > div": {
            backgroundColor: theme.palette.cell.tableHover,
            position: "relative",
            "& > div": {
                zIndex: 3,
            },
        },
        "&[data-sticky-first-right-td]:not(th) > div::before": {
            content: "''",
            position: "absolute",
            display: "block",
            top: 0,
            left: "-8px",
            width: "8px",
            height: "100%",
            background: `linear-gradient(270deg, #F5F9FF 0%, rgba(245, 249, 255, 0) 50%)`,
        },
        "&[data-sticky-first-right-td]:not(th) > div::after": {
            content: "''",
            position: "absolute",
            display: "block",
            zIndex: 1,
            top: 0,
            left: 0,
            width: "125%",
            height: "100%",
            backgroundColor: theme.palette.cell.tableHover,
        },
    },
    showFirstColumnShadow: {
        "& [data-sticky-last-left-td]:not(th)": {
            boxShadow: `inset -1px 0 0 0 ${theme.palette.border.menuContainer} !important`,
        },
        "& [data-sticky-last-left-td]:not(td)": {
            boxShadow: `inset -1px 0 0 0 ${theme.palette.border.menuContainer} !important`,
        },
    },
    list: {
        overflow: "hidden auto !important",
    },
    rowHoverStyle: {
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.palette.cell.tableHover,
        },
        "& [data-sticky-last-left-td]:not(th)::after": {
            background: `linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, ${theme.palette.cell.tableHover} 100%)`,
        },
        "&:hover td:not([data-sticky-first-right-td]), &:focus td:not([data-sticky-first-right-td])": {
            backgroundColor: theme.palette.cell.tableHover,
        },
        //Стилизация компонент ховера
        "& > div:last-child:not(div:first-child)": {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-end",
            background: "none",
            position: "sticky",
            opacity: 0,
            right: 0,
            "& > div": {
                position: "relative",
                display: "flex",
                alignItems: "flex-start",
                height: "100%",
                background: "#F5F9FF",
                "&::before": {
                    position: "absolute",
                    content: "''",
                    left: "-8px",
                    width: "8px",
                    height: "100%",
                    background: "linear-gradient(270deg, #F5F9FF 0%, rgba(245, 249, 255, 0) 50%)",
                },
            },
        },
        "&:hover > div:last-child:not(div:first-child)": {
            opacity: 1,
        },
    },
    rowWOFooter: {
        "&:last-child": {
            borderBottom: "none !important",
        },
    },
}));
export default FTLTableStyles;
//# sourceMappingURL=FTLTableStyles.styles.js.map